import { useState, useEffect, useRef } from "react";
import { Modal, Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { useTranslation } from 'react-i18next'


const _formData = {
    timeFrom: "",
    timeTo: "",
    breakTime: 0
}

const isValidTime = (raw) =>
    raw.length === 4 &&
    parseInt(raw.slice(0, 2)) <= 23 &&
    parseInt(raw.slice(2)) <= 59

const AddSeriesModal = (props) => {
    const { handleClose, createSeries } = props
    const innerRef = useRef()
    const { t } = useTranslation()

    const [formData, setFormData] = useState({ ..._formData })
    const [validated, setValidated] = useState(false)

    //autofocus
    useEffect(() => { innerRef.current && innerRef.current.focus() }, []);

    //cleanup
    useEffect(() => {
        return () => clearData()
    }, [])

    const clearData = () => {
        setFormData({ ..._formData })
        setValidated(false)
    }

    const handleTimeInput = (e) => {
        const { name } = e.target
        const raw = e.target.value.replace(/\D/g, '').slice(0, 4)
        const formatted = raw.length >= 3 ? raw.slice(0, 2) + ':' + raw.slice(2) : raw
        const newData = { ...formData, [name]: formatted }
        setFormData(newData)
        const fromRaw = newData.timeFrom.replace(':', '')
        const toRaw = newData.timeTo.replace(':', '')
        setValidated(
            isValidTime(fromRaw) &&
            isValidTime(toRaw) &&
            newData.breakTime !== ''
        )
    }

    const handleInputChange = (event) => {
        const newData = { ...formData, [event.target.name]: event.target.value }
        setFormData(newData)
        const fromRaw = newData.timeFrom.replace(':', '')
        const toRaw = newData.timeTo.replace(':', '')
        setValidated(
            isValidTime(fromRaw) &&
            isValidTime(toRaw) &&
            newData.breakTime !== ''
        )
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        event.stopPropagation()

        if (validated) {
            createSeries(formData)
            handleClose()
        }
    }

    return (
        <>
            <Modal style={{ textAlign: "center" }} centered show={true} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title >{t('appointment:addTime')}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form
                        id="my-form"
                        onSubmit={handleSubmit}
                    >
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('start')}</Form.Label>
                                    <Form.Control
                                        ref={innerRef}
                                        name="timeFrom"
                                        type="text"
                                        placeholder="HH:MM"
                                        value={formData.timeFrom}
                                        onChange={handleTimeInput}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('end')}</Form.Label>
                                    <Form.Control
                                        name="timeTo"
                                        type="text"
                                        placeholder="HH:MM"
                                        value={formData.timeTo}
                                        onChange={handleTimeInput}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('appointment:breakBetween')}</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            name="breakTime"
                                            type="number"
                                            min="0"
                                            value={formData.breakTime}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        <InputGroup.Text id="basic-addon2">{t('minutes')}</InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body >
                <Modal.Footer >
                    <Button
                        form="my-form"
                        variant='primary'
                        disabled={!validated}
                        type="submit"
                    >
                        {t('create')}
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default AddSeriesModal;
